<template>
  <div>
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Vouchers By Customer - Finance</h3>
        <div class="ReportsCriteria">
          <span>
            <label for="cust-select">Customer to Charge</label><br/>
            <select id="cust-select" v-model="SelectedCustomer" class ="contractCustomer" @change="listVaccinations()" >
                <option value="" selected disabled >Customer to be charged</option>
                <option value="All">All</option>
                <option v-for="Customer in sortedchargeTo"
                  :value="Customer.name"
                  :key="Customer.id"
                  >
                  {{Customer.chargeTo}}
                </option>
            </select>
          </span>
          <span class="ReportsCriteriaDate ReportsCriteria">
            <label for="startdate">Start Date</label><br/>
            <input id="startdate" type="date"
              :value="fromDate && new Date(fromDate.getTime()-(fromDate.getTimezoneOffset()*60*1000)).toISOString().split('T')[0]"
              @input="UpdateDate('from', $event.target.valueAsDate)"
              @change="listVaccinations()"
              >
          </span>
          <span class="ReportsCriteriaDate ReportsCriteria">
            <label for="enddate">End Date</label><br/>
            <input id="enddate" type="date"
            :value="toDate && new Date(toDate.getTime()-(toDate.getTimezoneOffset()*60*1000)).toISOString().split('T')[0]"
            @input="UpdateDate('to', $event.target.valueAsDate)"
            @change="listVaccinations()"
            >
          </span>
          <span class="ReportsCriteriaDate ReportsCriteria">
            <br/>
            <button @click="tableToExcel('VaccinationTable', SelectedCustomer)" class="ReportsExcel">
              <img src="@/assets/Excel32a.png" />
            </button>
          </span>
        </div>
        <div v-if="SelectedCustomer">
          <div class="page-loader" v-if="!isloaded">
            <PageLoader />
          </div>
          <div v-else-if="toDate >= fromDate">
            <table ref="table" id="VaccinationTable" class="Customer-table DisplayTable" >
              <thead>
                <tr>
                  <th class="ReportsDescription">Company Name</th>
                  <th class="ReportsDescription">Description</th>
                  <th>Quantity</th>
                  <th class="ReportsVoucher">Unit Price (Excl GST)</th>
                  <th class="ReportsDescription">Description on Invoice</th>
                  <th class="ReportAttributes-cell">Invoice Amount <br />(Excl GST)</th>
                </tr>
              </thead>
              <tbody v-for= "(Vaccination, Index) in SummarisedAmts" :key="Index" class="ReportsTable">
                <tr height="30px" class="ReportsTable">
                  <td class="ReportsCell-left">{{Vaccination.chargeTo}}</td>
                  <td class="ReportsCell-left ">{{Vaccination.customer}}</td>
                  <td class="ReportsCell-centre">{{Vaccination.qty}}</td>
                  <td class="ReportsCell-right">{{Vaccination.price | PriceDisplay}}</td>
                  <td class="ReportsCell-left">{{Vaccination.description}}</td>
                  <td class="ReportsCell-right">{{Vaccination.amt | PriceDisplay}}</td>
                </tr>
              </tbody>
              <tfoot class="ReportsTable">
                <tr v-if ="SelectedCustomer">
                  <td class="ReportsCell-left">Total</td>
                  <td></td>
                  <td>{{TotalVouchers}}</td>
                  <td></td>
                  <td></td>
                  <td class="ReportsCell-right">{{TotalAmt | PriceDisplay}}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div v-if="message" class="errormessage">
        <table>
          <tr>
            <td>{{message}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import Vue from 'vue';
import { listCustomers } from '../../graphql/queries';
import { getProduct } from '../../graphql/queries';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";
import { listProducts } from '../../graphql/queries';
import PageLoader from "@/components/PageLoader";

export default {
  name: 'app',
  components:{
    RwvMenu,
    PageLoader,
  },
  async created() {
 //    console.log('created ...');
    this.listCustomers();
    this.setDates();
    this.listProducts();
    this.UpdateSummary();
//     console.log('created end');
  },
  data() {
    return {
      Vaccinations: [],
      Customers: [],
      chargeTo: [],
      currentSort: 'chargeTo',
      currentSortDir: 'asc',
      SelectedCustomer: '',
      Products: [],
      fromDate: '',
      toDate: '',
      message: '',
      SummarisedAmts: [],
      TotalVouchers: 0,
      TotalAmt: 0,
      isloaded: true,
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }

    }
  },
  filters:{
    VaccinationsDate: (str) => {
      if (!str) { return '(n/a)'; }
      str = new Date(str);
      return ((str.getDate() < 10) ? '0' : '') + str.getDate()+ '-' + ((str.getMonth() < 9) ? '0' : '') + (str.getMonth() + 1) + '-'
         + str.getFullYear() + ' ' + ((str.getHours() < 10) ? '0' : '') + str.getHours() + ":" + ((str.getMinutes() < 10) ? '0' : '') + str.getMinutes();
      },
    PriceDisplay: (str) => {
      var prc = str * 1;
      var formatter = new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD',
        });
       return formatter.format(prc);
    }
  },
  methods: {
    async listVaccinations() {
//      console.log('listVaccination ...');
      this.TotalVaccinations = 0;
      this.message = "";
      if (this.toDate < this.fromDate) {
        this.message = "End Date must be greater than or equal to Start Date"
      }
      else {
        if (this.SelectedCustomer) {
          this.isloaded = false
          try {
            if (this.SelectedCustomer === "All"){
              this.Vaccinations = await commonFunctions.getAllVacinations(this.fromDate, this.toDate);
            }
            else {
              this.Vaccinations = await commonFunctions.getVaccinationsChargeTo(this.SelectedCustomer, this.fromDate, this.toDate)
            }
            for (var i=this.Vaccinations.length - 1; i>=0; i--) {
              this.Vaccinations[i].customerName = this.findObjectByKey(this.Customers, 'id', this.Vaccinations[i].contract.customerId).name;
              this.Vaccinations[i].product = this.findObjectByKey(this.Products, 'id', this.Vaccinations[i].contract.productId).description;
              this.Vaccinations[i].price = this.findObjectByKey(this.Products, 'id', this.Vaccinations[i].contract.productId).price;
           }
            this.UpdateSummary();
          }
          catch (error) {
            console.log(error)
            this.message = commonFunctions.displayError(error);
          }
          finally {
            this.isloaded = true;
          }
        }
      }
//      console.log('listVaccination end');
    },
    sort: function(s) {
//       console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },
    async listCustomers() {
//       console.log("listCustomers ...")
      var limit = 1000;
      try {
        const Customers = await API.graphql({
          query: listCustomers,
          variables: {limit: limit}
          }
        );
        this.Customers = Customers.data.listCustomers.items;
        this.chargeTo = JSON.parse(JSON.stringify(this.Customers));
        var i;
        for(i=this.chargeTo.length-1; i >= 0; i--){
          if(this.chargeTo[i].name != this.chargeTo[i].chargeTo) {
            this.chargeTo.splice(i,1);
          }
        }
        this.$forceUpdate();
      }
      catch (error) {
 //       console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('getCustomers end ...')
    },
    async getProduct(){
//       console.log('getProduct ...');
      try {
        var i;
        for (i=this.Vaccinations.length - 1; i>=0; i--) {
          const id = this.Vaccinations[i].contract.productId;
          const QueryVariables = {id};
          const Product = await API.graphql({
            query: getProduct,
            variables: QueryVariables,
            });
            Vue.set(this.Vaccinations[i], 'product', Product.data.getProduct.description);
            Vue.set(this.Vaccinations[i], 'price', Product.data.getProduct.price)
        }
        this.$forceUpdate();
      }
      catch (error) {
//        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      this.UpdateSummary(); 

      // console.log('getProduct end');
    },
    async listProducts() {
      // console.log('getProducts ...')
      var limit = 1000;
      try {
        const products = await API.graphql({
          query: listProducts,
          variables: {limit: limit}
        });
        this.Products = products.data.listProducts.items;
        var i;
        for (i=0; i<this.Products.length; i++) {
          this.Products[i].price = this.Products[i].price.toFixed(2);
        }
      }
      catch (error) {
//        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('getProducts end ...')
    },
        
    findObjectByKey: function(array, key, value) {
      try {
      if(array.length > 0){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
      }
      return "not found";
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
    },

    UpdateSummary() {
//      console.log('UpdateSummary ...');
      this.SummarisedAmts = [];
      let sumsArray = {};
      this.TotalVouchers = 0;
      this.TotalAmt = 0;
      var sums 
      this.sortedVaccinations.forEach(item => {
        sums = sumsArray[item.customerName + item.product]
        if(sums) {
          sums.qty += 1;
          sums.amt = ((sums.amt*1) + (item.price*1)).toFixed(2);
        }
        else{
          sumsArray[item.customerName + item.product] = {
            chargeTo: item.chargeTo,
            customer: item.customerName,
            product: item.product,
            description: item.product + " - " + item.customerName,
            qty: 1,
            price: item.price,
            amt:item.price
          }
        }
        this.TotalAmt = ((this.TotalAmt * 1) + (item.price * 1)).toFixed(2);
        this.TotalVouchers += 1;
        this.SummarisedAmts = sumsArray;
      });
    },
    setDates() {
//       console.log('setDates ...');
      var date1 = new Date();
      date1.setDate(1)
      date1.setHours(0,0,0,0);
      this.fromDate = date1;
      var date2 = new Date();
      var lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
      date2.setDate(lastDayOfMonth.getDate())
      date2.setHours(23,59,59,99);
      this.toDate = date2;
      // console.log('setDates end');
    },
    UpdateDate(d, v){
      // console.log('UpdateDate ...');
      var date1 = new Date(v);
      if (d =='from'){
        date1.setHours(0,0,0,0);
        this.fromDate = date1;
      }
      else{
        date1.setHours(23,59,59,99)
        this.toDate = date1;
      }
      this.UpdateSummary();
      // console.log('UpdateDate end');
    },

    tableToExcel(table, SelectedCustomer){
//      console.log('tableToExcel ...', table);
      if (!table.nodeType) table = this.$refs.table
      var header = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Customer Details</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>'
      var dataTable = table.innerHTML
      var footer = "</table></body></html>";
      var tabla = header + dataTable + footer;
      var myBlob =  new Blob( [tabla] , {type:'application/vnd.ms-excel'});
      var url = window.URL.createObjectURL(myBlob);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = "FinanceCustomer - " + SelectedCustomer + ".xls";
      a.click();
      setTimeout(function() {window.URL.revokeObjectURL(url);},0);
 //     console.log('tableToExcel end');
//});
 //     if (!table.nodeType) table = this.$refs.table
 //     var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
 //     window.location.href = this.uri + this.base64(this.format(this.template, ctx))
    }
  },

  computed: {
    sortedVaccinations: function() {
//       console.log('sortedVaccinations ...');
      return this.Vaccinations.slice().sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a.chargeTo.toLowerCase() + a.customerName.toLowerCase() < b.chargeTo.toLowerCase() + b.customerName.toLowerCase()) return -1 * modifier;
        if(a.chargeTo.toLowerCase() + a.customerName.toLowerCase() > b.chargeTo.toLowerCase() + b.customerName.toLowerCase()) return 1 * modifier;
        return 0;
      });
    },
/*
    filteredVaccinations: function() {
 //     console.log('filteredVaccinations ...');
      let result = this.Vaccinations;
      if (!this.SelectedCustomer) {return result}
      const filterValue = this.SelectedCustomer;
      if (this.SelectedCustomer === "All"){
        const filter = event =>
          new Date(event.vaccinationDate) >= new Date(this.fromDate)
          && new Date(event.vaccinationDate) <= new Date(this.toDate)
          return result.filter(filter)
       }
      else{
        const filter = event =>
        event.contract.customer.chargeTo === filterValue 
        && new Date(event.vaccinationDate) >= new Date(this.fromDate)
        && new Date(event.vaccinationDate) <= new Date(this.toDate)
        return result.filter(filter)
        }
    },
  */
    sortedchargeTo: function() {
//      console.log('sortedchargeTo ...');
      return this.chargeTo.slice().sort((a,b) => {
        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
    }
  }
}
</script>
<style>

</style>

